export namespace Disney {
	export enum Studio {
		Disney = "Disney",
		Pixar = "Pixar",
		Lucasfilm = "Lucasfilm",
		Marvel = "Marvel",
		Other = "Other",
	}

	export type Entry = {
		Title: string
		Released: Date | null
		Studio: Studio
		DisneyPlus?: string
	}

	const starWars: Entry[] = [
		{
			Released: new Date("1999-05-19 10:00:00Z"),
			Studio: Studio.Lucasfilm,
			Title: "Star Wars: The Phantom Menace",
		},
		{
			Released: new Date("2002-05-16 10:00:00Z"),
			Studio: Studio.Lucasfilm,
			Title: "Star Wars: Attack of the Clones",
		},
		{
			Released: new Date("2005-05-19 10:00:00Z"),
			Studio: Studio.Lucasfilm,
			Title: "Star Wars: Revenge of the Sith",
		},
		{
			Released: new Date("1977-05-25 10:00:00Z"),
			Studio: Studio.Lucasfilm,
			Title: "Star Wars: A New Hope",
		},
		{
			Released: new Date("1980-05-12 10:00:00Z"),
			Studio: Studio.Lucasfilm,
			Title: "Star Wars: The Empire Strikes Back",
		},
		{
			Released: new Date("1983-05-25 10:00:00Z"),
			Studio: Studio.Lucasfilm,
			Title: "Star Wars: Return of the Jedi",
		},
		{
			Released: new Date("2015-12-18 10:00:00Z"),
			Studio: Studio.Lucasfilm,
			Title: "Star Wars: The Force Awakens",
		},
		{
			Released: new Date("2017-12-15 10:00:00Z"),
			Studio: Studio.Lucasfilm,
			Title: "Star Wars: The Last Jedi",
		},
		{
			Released: new Date("2019-12-20 10:00:00Z"),
			Studio: Studio.Lucasfilm,
			Title: "Star Wars: The Rise of Skywalker",
		},
		{
			Released: new Date("1981-06-12 10:00:00Z"),
			Studio: Studio.Lucasfilm,
			Title: "Raiders of the Lost Ark",
		},
	]

	export const Entries: Entry[] = [
		...starWars,
		{
			Released: new Date("1937-12-21 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Snow White and the Seven Dwarfs",
		},
		{
			Released: new Date("1940-02-07 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Pinocchio",
		},
		{
			Released: new Date("1940-11-13 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Fantasia ",
		},
		{
			Released: new Date("1941-10-23 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Dumbo",
		},
		{
			Released: new Date("1942-08-21 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Bambi",
		},
		{
			Released: new Date("1945-02-03 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "The Three Caballeros",
		},
		{
			Released: new Date("1949-10-05 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "The Adventures of Ichabod and Mr. Toad",
		},
		{
			Released: new Date("1950-02-15 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Cinderella",
		},
		{
			Released: new Date("1951-07-28 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Alice in Wonderland",
		},
		{
			Released: new Date("1953-02-05 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Peter Pan",
		},
		{
			Released: new Date("1954-12-23 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "20,000 Leagues Under the Sea",
		},
		{
			Released: new Date("1955-06-22 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Lady and the Tramp",
		},
		{
			Released: new Date("1959-01-29 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Sleeping Beauty",
		},
		{
			Released: new Date("1960-12-21 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Swiss Family Robinson",
		},
		{
			Released: new Date("1961-01-25 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "One Hundred and One Dalmatians",
		},
		{
			Released: new Date("1963-12-25 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "The Sword in the Stone",
		},
		{
			Released: new Date("1964-08-29 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Mary Poppins",
		},
		{
			Released: new Date("1967-10-18 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "The Jungle Book",
		},
		{
			Released: new Date("1973-11-08 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Robin Hood",
		},
		{
			Released: new Date("1977-03-11 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "The Many Adventures of Winnie the Pooh",
		},
		{
			Released: new Date("1982-07-09 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Tron",
		},
		{
			Released: new Date("1989-06-23 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Honey, I Shrunk the Kids",
		},
		{
			Released: new Date("1989-11-17 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "The Little Mermaid",
		},
		{
			Released: new Date("1991-11-22 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Beauty and the Beast",
		},
		{
			Released: new Date("1992-11-25 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Aladdin",
		},
		{
			Released: new Date("1994-06-24 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "The Lion King",
		},
		{
			Released: new Date("1995-04-07 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "A Goofy Movie",
		},
		{
			Released: new Date("1995-06-23 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Pocahontas",
		},
		{
			Released: new Date("1995-11-22 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "Toy Story",
		},
		{
			Released: new Date("1996-06-21 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "The Hunchback of Notre Dame",
		},
		{
			Released: new Date("1997-06-27 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Hercules",
		},
		{
			Released: new Date("1997-11-26 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Flubber",
		},
		{
			Released: new Date("1998-06-19 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Mulan",
		},
		{
			Released: new Date("1998-11-20 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "A Bug's Life",
		},
		{
			Released: new Date("1999-06-18 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Tarzan",
		},
		{
			Released: new Date("1999-11-24 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "Toy Story 2",
		},
		{
			Released: new Date("2000-05-19 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Dinosaur",
		},
		{
			Released: new Date("2000-12-15 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "The Emperor's New Groove",
		},
		{
			Released: new Date("2001-06-15 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Atlantis: The Lost Empire",
		},
		{
			Released: new Date("2001-11-02 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "Monsters, Inc.",
		},
		{
			Released: new Date("2002-06-21 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Lilo & Stitch",
		},
		{
			Released: new Date("2002-11-27 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Treasure Planet",
		},
		{
			Released: new Date("2003-05-30 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "Finding Nemo",
		},
		{
			Released: new Date("2003-07-09 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Pirates of the Caribbean: The Curse of the Black Pearl",
		},
		{
			Released: new Date("2004-11-05 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "The Incredibles",
		},
		{
			Released: new Date("2006-06-09 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "Cars",
		},
		{
			Released: new Date("2007-06-29 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "Ratatouille",
		},
		{
			Released: new Date("2008-06-27 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "WALL-E",
		},
		{
			Released: new Date("2009-05-29 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "Up",
		},
		{
			Released: new Date("2009-12-11 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "The Princess and the Frog",
		},
		{
			Released: new Date("2009-12-18 10:00:00Z"),
			Studio: Studio.Other,
			Title: "Avatar",
		},
		{
			Released: new Date("2010-06-18 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "Toy Story 3",
		},
		{
			Released: new Date("2010-11-24 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Tangled",
		},
		{
			Released: new Date("2010-12-17 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Tron: Legacy",
		},
		{
			Released: new Date("2011-06-24 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "Cars 2",
		},
		{
			Released: new Date("2012-06-22 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "Brave",
		},
		{
			Released: new Date("2012-11-02 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Wreck-It Ralph",
		},
		{
			Released: new Date("2013-06-21 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "Monsters University",
		},
		{
			Released: new Date("2013-11-27 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Frozen",
		},
		{
			Released: new Date("2013-12-13 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Saving Mr. Banks",
		},
		{
			Released: new Date("2014-11-07 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Big Hero 6",
		},
		{
			Released: new Date("2015-06-19 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "Inside Out",
		},
		{
			Released: new Date("2016-03-04 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Zootopia",
		},
		{
			Released: new Date("2016-06-17 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "Finding Dory",
		},
		{
			Released: new Date("2016-11-23 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Moana",
		},
		{
			Released: new Date("2017-06-16 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "Cars 3",
		},
		{
			Released: new Date("2017-11-22 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "Coco",
		},
		{
			Released: new Date("2018-06-15 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "Incredibles 2",
		},
		{
			Released: new Date("2018-08-03 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Christopher Robin",
		},
		{
			Released: new Date("2018-11-21 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Ralph Breaks the Internet",
		},
		{
			Released: new Date("2018-12-19 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Mary Poppins Returns",
		},
		{
			Released: new Date("2019-06-21 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "Toy Story 4",
		},
		{
			Released: new Date("2020-03-06 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "Onward",
		},
		{
			Released: new Date("2019-11-22 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Frozen II",
		},
		{
			Released: new Date("2020-12-25 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "Soul",
		},
		{
			Released: new Date("2021-03-05 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Raya and the Last Dragon",
		},
		{
			Released: new Date("2021-06-18 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "Luca",
		},
		{
			Released: new Date("2021-11-24 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Encanto",
		},
		{
			Released: new Date("2022-03-11 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "Turning Red",
		},
		{
			Released: new Date("2023-06-16 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "Elemental",
		},
		{
			Released: new Date("2023-11-22 10:00:00Z"),
			Studio: Studio.Disney,
			Title: "Wish",
		},
		{
			Released: new Date("2024-06-14 10:00:00Z"),
			Studio: Studio.Pixar,
			Title: "Inside Out 2",
		},
	]
}
